export default __webpack_public_path__ + "static/media/comodo.5816c3e9.svg";